import { render, staticRenderFns } from "./LeaplyMap.vue?vue&type=template&id=2940b5bb"
import script from "./LeaplyMap.vue?vue&type=script&lang=js"
export * from "./LeaplyMap.vue?vue&type=script&lang=js"
import style0 from "./LeaplyMap.vue?vue&type=style&index=0&id=2940b5bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports